import * as M from 'shared/types/models';

export function getDefaultCellTooltip(cell: M.AbstractCell) {
  if (M.typeGuards.isTypedCell(cell) && cell.fullContent && cell.fullContent.originalValue !== cell.content) {
    return `Исходное значение: "${cell.fullContent.originalValue}"`;
  }

  return null;
}
